import { render, staticRenderFns } from "./PlatformFeeCopyForm.vue?vue&type=template&id=d16c24de&scoped=true&"
import script from "./PlatformFeeCopyForm.vue?vue&type=script&lang=js&"
export * from "./PlatformFeeCopyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16c24de",
  null
  
)

export default component.exports